/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import moment from 'moment-timezone';
import config from 'js-sdk/src/jrs.configs';
// @ts-ignore
import dateUtils from 'js-sdk/src/common/util/parse/date';
import formatsMappingUtil from './formatsMappingUtil';
import dateFormatter from './dateFormatter';
import {
    Formatter, Options, Categorizer
} from './types';

function momentLocaleTimezone(value: string): moment.Moment {
    return moment(value)
        .locale(config.userLocale)
        .tz(config.userTimezone);
}

function AmPmForZhCN(value: string): string {
    // 上午 = A.M.
    // 下午 = P.M.
    // TODO: radix looks invalid
    // eslint-disable-next-line radix
    return parseInt(momentLocaleTimezone(value).format('HH'), 0) >= 12 ? '下午' : '上午';
}

export default {
    format(val: string, format?: string, options?: Options): string {
        if (formatsMappingUtil.isEmpty(val)) {
            return '';
        }
        if (formatsMappingUtil.isOtherNode(val)) {
            return val;
        }
        if (formatsMappingUtil.shouldBeFormattedByDateFormatter(options)) {
            return dateFormatter.format(val, format, options);
        }
        if (formatsMappingUtil.shouldBeReturnedAsLocalizedDayOfWeek(options)) {
            return formatsMappingUtil.getLocalizedDayOfWeek(val);
        }
        let formatForMoment = formatsMappingUtil.getFormatForMoment(format, options) || dateUtils.fromJavaToMomentTimestampPattern(format);
        if (formatForMoment) {
            let value;
            if (/^zh/.test(config.userLocale)) {
                formatForMoment = formatForMoment.replace('A', AmPmForZhCN(formatsMappingUtil.convertTimeToIso(val)));
            }
            if (options && (options as Categorizer).useUserTimezone) {
                value = formatsMappingUtil.setToUserTimezone(val);
            } else {
                value = formatsMappingUtil.ensureTimezone(val);
            }
            const convertedToISO = formatsMappingUtil.convertTimeToIso(value);
            const momentObject = momentLocaleTimezone(convertedToISO);
            return momentObject.format(formatForMoment);
        }
        return val;
    }
} as Formatter;
